<div class="top-container">
  <div class="data-wrapper" *ngFor="let item of aggregatedData; let i = index" [ngClass]="i < aggregatedData.length - 1 ? 'partition' : ''">
    <p class="label">{{ item.label }}</p>
    <div class="data-content">
      <h4 class="fw-bold data-value">{{ item.value }}</h4>
      <h6 class="fw-bold data-unit">{{ item.suffix }}</h6>
    </div>
  </div>
</div>
<app-custom-toggle-btn *ngIf="showTimeFrameModeToggle" (onChangeTimeFrame)="onTimeFrameChange($event)" [isRightPosition]="true"></app-custom-toggle-btn>
<div class="scrollable-chart-wrapper">
  <app-scrollable-chart [chartData]="chartData" [chartParams]="chartParams" [timeFrameMode]="timeFrameMode"></app-scrollable-chart>
</div>
